/**
 * @file paddleSuilte 的 api
 * @author FengGuang(fengguang01@baidu.com)
 */
import baseRequest2 from '../baseApi2';
import request from 'superagent';

export const fetchGetDownloadInfo = () => (
    baseRequest2(
        request.get('/platform/page/data')
            .query({requestUrl: '/paddlex/download'})
            .query(window.location.search.slice(1))
    )
);

export const fetchGetHistoryInfo = () => (
    baseRequest2(
        request.get('/platform/page/data')
            .query({requestUrl: '/paddlex/history'})
            .query(window.location.search.slice(1))
    )
);

export const fetchGetReleaseNote = () => (
    baseRequest2(
        request.get('/platform/page/data')
            .query({requestUrl: '/paddlex/releasenote'})
            .query(window.location.search.slice(1))
    )
);

interface IUserInfoSubmitParams {
    nickname: string;
    username: string;
    email: string
    mobile: string;
    centerUserType: string;
    developerLocationProvince: string;
    developerLocationCity: string;
    industry: string;
    developerCompany: string;
    developerPosition: string;
    scene: string;
    otherUserType: string;
    verifyCode: string;
    randomStr: string;
    source: string;
}

export const fetchSubmitUserInfo = (params: IUserInfoSubmitParams) => (
    baseRequest2(
        request.post('/platform/usercase/send')
            .query({type: 13})
            .send(params)
    )
);
